module.exports = __webpack_public_path__ + "img/EnterpriseWeChat.84232763.jpg";